import type { ModifierKeys, Platform, TriggerKey } from '.';

export class KeyboardShortcutParseError extends Error {}

export interface IKeys {
  modifiers: ModifierKeys[];
  key: TriggerKey;
  toString(): string;
  toPlatformString(platform: Platform): string;
  toTooltipHint(platform: Platform): string;
  equals(keys: IKeys): boolean;
}
